import { Model } from 'modules/core/lib/mobx-rest'

import { IntegrationTools } from 'modules/payroll_integrations_kombo/lib/constants'

export type Status = keyof typeof STATUSES

const enum STATUSES {
  pending = 'pending',
  synced = 'synced',
  failed = 'failed',
}

interface IKomboSupplementSync {
  supplement_id: string
  pending: boolean
  sent_at: string
  integration_tool: IntegrationTools
}

class KomboSupplementSync extends Model<IKomboSupplementSync> {
  static urlRoot() {
    return '/payroll_integrations/kombo/supplement_syncs'
  }

  constructor(attr: IKomboSupplementSync) {
    super(attr)
  }

  get supplement_id(): string {
    return this.attributes.supplement_id
  }

  get pending(): boolean {
    return this.attributes.pending
  }

  get sent_at(): string {
    return this.attributes.sent_at
  }

  get status(): Status {
    return this.isSynced ? STATUSES.synced : STATUSES.pending
  }

  get isSynced(): boolean {
    return !this.pending
  }

  get integrationTool(): IntegrationTools {
    return this.attributes.integration_tool
  }
}

export default KomboSupplementSync
